let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <adjustmentOrder>
        <adjustmentOrderCode>转移单号(ERP单号), string (50), 必填</adjustmentOrderCode>
        <adjustmentOrderType>转移单类型, string (50),  例如: ZCTZ=转仓调整单,KCYK=库存移库, 必填</adjustmentOrderType>
        <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
        <ownerCode>货主编码, string (50), 必填</ownerCode>
        <createTime>创建时间, string (19), YYYY-MM-DD HH:MM:SS</createTime>
        <remark>备注, string (500)</remark>
    </adjustmentOrder>
    <orderLines>
        <orderLine>
            <itemCode>商品编码, string (50), 必填</itemCode>
            <itemId>仓储系统商品编码, string (50)</itemId>
            <itemName>商品名称, string (200)</itemName>
            <planQty>计划调整数量, int, 必填</planQty>
            <lineNo>行号, int</lineNo>
            <source>
                <inventoryType>原商品质量状态, string (50), ZP=正品, CC=残次, 默认为ZP</inventoryType>
                <virtualWarehouse>原商品虚拟仓库, string (50)</virtualWarehouse>
                <productDate>原商品生产日期, string (10), YYYY-MM-DD</productDate>
                <expireDate>原商品过期日期, string (10), YYYY-MM-DD</expireDate>
                <batchCode>原商品批次号, string (50)</batchCode>
                <stockinDate>原商品入库日期, string (10), YYYY-MM-DD</stockinDate>
                <userDefined1>原自定义批次1, string (50)</userDefined1>
                <userDefined2>原自定义批次2, string (50)</userDefined2>
                <userDefined3>原自定义批次3, string (50)</userDefined3>
                <userDefined4>原自定义批次4, string (50)</userDefined4>
            </source>
            <target>
                <inventoryType>目标商品质量状态, string (50), ZP=正品, CC=残次, 默认为ZP</inventoryType>
                <virtualWarehouse>目标商品虚拟仓库, string (50)</virtualWarehouse>
                <productDate>目标商品生产日期, string (10), YYYY-MM-DD</productDate>
                <expireDate>目标商品过期日期, string (10), YYYY-MM-DD</expireDate>
                <batchCode>目标商品批次号, string (50)</batchCode>
                <stockinDate>目标商品入库日期, string (10), YYYY-MM-DD</stockinDate>
                <userDefined1>目标自定义批次1, string (50)</userDefined1>
                <userDefined2>目标自定义批次2, string (50)</userDefined2>
                <userDefined3>目标自定义批次3, string (50)</userDefined3>
                <userDefined4>目标自定义批次4, string (50)</userDefined4>
            </target>
        </orderLine>
    </orderLines>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <message>响应信息</message>
    <adjustmentOrderId>仓储系统转移单号, string (50)</adjustmentOrderId>
    <createTime>转移单创建时间, string(19), YYYY-MM-DD HH:MM:SS</createTime>
</response>
`

export default { xmlRequest, xmlResponse }



// WEBPACK FOOTER //
// ./src/data/openapi/openapi.adjustmentorder.create.js